import styled from 'styled-components';

// {@code flex-shrink: 0} so the surrounding {@code PanelBody} flex
// column doesn't squash this card when total content overflows — the
// sidebar scrolls as a whole instead (consistent with the other dock
// cards: canvas info, agent log, execution log).
export const StatsCard = styled.div<{ $empty?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ $empty }) => ($empty ? '0' : '22px')};
  padding: ${({ $empty }) => ($empty ? '14px 14px' : '16px 14px 14px')};
  background: ${({ theme: { colors = {} } }) => colors.cardSurface ?? '#15151F'};
  border: 1px solid
    ${({ theme: { colors = {} } }) => colors.outlineVariant ?? '#25263A'};
  border-radius: 24px;
  flex-shrink: 0;
`;

export const StatsRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-around;
  gap: 12px;
`;

export const SparkSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SparkLabel = styled.span`
  font-size: 9px;
  line-height: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  text-align: center;
  opacity: 0.75;
  color: ${({ theme: { colors = {} } }) =>
    colors.onSurfaceVariant ?? '#A1A3B8'};
`;

